import { etapasEnum,etapasIndexEnum } from '@common/util/defaultValues';
import WebapiCommon from '@common/util/webapi.common';

export const ordemSugeridaEtapas = [
  { etapa: etapasEnum.MATERIAL, id: 'material_etapa', tab: etapasIndexEnum.MATERIAL },
  { etapa: etapasEnum.MACRO, id: 'macro_etapa', tab: etapasIndexEnum.MACRO },
  { etapa: etapasEnum.MICRO, id: 'micro_etapa', tab: etapasIndexEnum.MICRO },
  { etapa: etapasEnum.HISTO, id: 'histo_etapa', tab: etapasIndexEnum.HISTO },
  { etapa: etapasEnum.IMUNO, id: 'imuno_etapa', tab: etapasIndexEnum.IMUNO },
  { etapa: etapasEnum.FISH, id: 'fish_etapa', tab: etapasIndexEnum.FISH },
  { etapa: etapasEnum.CISH, id: 'cish_etapa', tab: etapasIndexEnum.CISH },
  { etapa: etapasEnum.PCR, id: 'pcr_etapa', tab: etapasIndexEnum.PCR },
  { etapa: etapasEnum.CONGELACAO, id: 'congelacao_etapa', tab: etapasIndexEnum.CONGELACAO },
  { etapa: etapasEnum.NOTAS, id: 'notas_etapa', tab: etapasIndexEnum.NOTAS },
  { etapa: etapasEnum.CONCLUSAO, id: 'conclusao_etapa', tab: etapasIndexEnum.CONCLUSAO },
  { etapa: etapasEnum.ERRATA, id: 'errata_etapa', tab: etapasIndexEnum.ERRATA }
];

export const atalhosEtapas = {
  'ctrl+alt+0': { nome: etapasEnum.MATERIAL, indice: etapasIndexEnum.MATERIAL },
  'ctrl+alt+1': { nome: etapasEnum.MACRO, indice: etapasIndexEnum.MACRO },
  'ctrl+alt+¹': { nome: etapasEnum.MACRO, indice: etapasIndexEnum.MACRO },
  'ctrl+alt+2': { nome: etapasEnum.MICRO, indice: etapasIndexEnum.MICRO },
  'ctrl+alt+²': { nome: etapasEnum.MICRO, indice: etapasIndexEnum.MICRO },
  'ctrl+alt+3': { nome: etapasEnum.HISTO, indice: etapasIndexEnum.HISTO },
  'ctrl+alt+³': { nome: etapasEnum.HISTO, indice: etapasIndexEnum.HISTO },
  'ctrl+alt+4': { nome: etapasEnum.IMUNO, indice: etapasIndexEnum.IMUNO },
  'ctrl+alt+£': { nome: etapasEnum.IMUNO, indice: etapasIndexEnum.IMUNO },
  'ctrl+alt+5': { nome: etapasEnum.FISH, indice: etapasIndexEnum.FISH },
  'ctrl+alt+¢': { nome: etapasEnum.FISH, indice: etapasIndexEnum.FISH },
  'ctrl+alt+6': { nome: etapasEnum.CISH, indice: etapasIndexEnum.CISH },
  'ctrl+alt+¬': { nome: etapasEnum.CISH, indice: etapasIndexEnum.CISH },
  'ctrl+alt+7': { nome: etapasEnum.PCR, indice: etapasIndexEnum.PCR },
  'ctrl+alt+8': { nome: etapasEnum.CONGELACAO, indice: etapasIndexEnum.CONGELACAO },
  'ctrl+alt+9': { nome: etapasEnum.NOTAS, indice: etapasIndexEnum.NOTAS },
  'ctrl+alt+c': { nome: etapasEnum.CONCLUSAO, indice: etapasIndexEnum.CONCLUSAO },
  'ctrl+alt+₢': { nome: etapasEnum.CONCLUSAO, indice: etapasIndexEnum.CONCLUSAO },
  'ctrl+alt+e': { nome: etapasEnum.ERRATA, indice: etapasIndexEnum.ERRATA },
  'ctrl+alt+°': { nome: etapasEnum.ERRATA, indice: etapasIndexEnum.ERRATA }
};

export const atalhosUtil = {
  'ctrl+alt+f10': { nome: 'fullScreenEditor', indice: '0' }
};

export const urlImagemRadiologia= (commonActions, acNumber, prontuario) => {
  commonActions.showFadeCarregando(true);
  WebapiCommon.obterUrlVivaceConnectAutenticada(acNumber, prontuario).then((result)=> {
    commonActions.showFadeCarregando(false);
    window.open(result.url);
  })
}



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/etapas.common.util.js